import { usePlatformActivity } from '@/entities/PlatformActivity/api/platform-activity-api'
import { Text, SimpleGrid } from '@mantine/core'
import { PlatformActivitySkeleton } from '../Skeletons/PlatformActivitySkeleton'
import { useTranslation } from 'react-i18next'
import { UserActivities } from '@/shared/api/topli/TopliApi'
import { StatCard } from '../Skeletons/StatCard'
import { DAUChart } from '../DAUChart/DAUChart'
import { MAUChart } from '../MAUChart/MAUChart'

const matchData = (data: UserActivities) => {
  return Object.entries(data).map(([key, value]) => ({
    ...value,
    title: key,
  }))
}

export const PlatformActivityStats = () => {
  const {
    data: platformActivity,
    isLoading: isLoadingPlatformActivity,
    isError: isErrorplatformActivity,
  } = usePlatformActivity()
  const { t } = useTranslation(['dashboard'])

  const formattedData = platformActivity && matchData(platformActivity.user_activities)

  if (isErrorplatformActivity) {
    return <>{t('common:error_messages.something_went_wrong')}</>
  }

  return (
    <div className='flex flex-col md:w-full w-full gap-y-4 mb-5'>
      <div className='flex flex-row justify-between w-full'>
        {isLoadingPlatformActivity ? (
          <PlatformActivitySkeleton />
        ) : (
          <SimpleGrid
            cols={3}
            spacing='md'
            className='w-full md:grid-cols-3 sm:grid-cols-2 grid-cols-1'
          >
            {formattedData &&
              formattedData.map(item => (
                <StatCard
                  key={item.title}
                  title={t(`dashboard:${item.title}`)}
                  total={item.total}
                  footer={
                    item.diff != null && (
                      <Text c='dimmed' fz='sm' mt='md'>
                        <Text component='span' c='teal' fw={700}>
                          {`${item.diff}% `}
                        </Text>
                        {t('dashboard:compared_7_days')}
                      </Text>
                    )
                  }
                />
              ))}
          </SimpleGrid>
        )}
      </div>
      {platformActivity?.sessions_history && (
        <div className='flex flex-col md:w-full w-full gap-y-4 mt-5 mb-5'>
          <DAUChart
            data={platformActivity?.sessions_history}
            isLoading={isLoadingPlatformActivity}
          />
          <MAUChart
            data={platformActivity?.sessions_history}
            isLoading={isLoadingPlatformActivity}
          />
        </div>
      )}
    </div>
  )
}
